/**
 * @typedef {object} StatsBenchmarkingState
 * @property {boolean} isActive
 */

/**
 * @typedef {object} StatsSortState
 * @property {string} columnId
 * @property {'ascending'|'descending'} sortDirection
 * @property {boolean} force
 */